import {createRouter, createWebHashHistory} from "vue-router";
import routes from "@/routes"
import Auth from "@/services/Auth"
import {store} from "@/store"
import catalogNavigation from "@/pages/catalog/navigation"


const router = createRouter({
  history: createWebHashHistory("/map/"),
  routes
})

Auth.initProfile()

function isPageNotFound(to) {
  return !to.matched.length
}
function isAuthRequired(to) {
  // auth required by default, except for login page
  return to.matched.some(page => page.meta.auth !== false)
}
function isModuleRequired(to) {
  return to.matched.some(page => {
    return !!page.meta.module
  })
}
function doesUserHaveRequiredModules(to) {
  let userModules = Auth.getModules()
  if (!userModules) return true
  return to.matched.every(page => {
    if (page.meta.module) {
      return userModules.includes(page.meta.module)
    }
    return true
  })
}
function checkModule(to) {
  let moduleIsNotRequired = !isModuleRequired(to)
  let userHasRequiredModules = doesUserHaveRequiredModules(to)
  return moduleIsNotRequired || userHasRequiredModules
}
function isPageLogin(to) {
  return to.meta.login
}
const catalogLinksToLabels = catalogNavigation.reduce((acc, group) => {
  if (group?.items?.length) {
    group.items.forEach(item => {
      if (item?.link && item?.label) {
        acc[item.link] = item.label
      }
    })
  }
  return acc
}, {})

function getCatalogTitle(to) {
  const type = to.params?.type
  if (!type) {
    return "Справочники"
  }
  const linkKey = `catalog/${type}`
  return catalogLinksToLabels[linkKey] || "Справочники"
}

function isCatalogRoute(to) {
  return to.path?.startsWith("/catalog")
}

function setDocumentTitle(to) {
  if ((Auth.isAuthenticated() || isPageLogin(to))) {
    let title = to.meta.title
    if (!title && isCatalogRoute(to)) {
      title = getCatalogTitle(to)
    }
    document.title = title ? title : "Agrostream"
  }
}
function sendStatistics(to) {
  // в компоненте после изменении document.title
  setTimeout(() => {
    if (document.title !== "Agrostream") {
      store.dispatch("PageViewRecords/actionSetRecord", {to: to.fullPath, title: document.title})
    }
  }, 500)

}

function startTransition() {
  store.dispatch("Router/actionSetTransition", true)
}
function stopTransition() {
  store.dispatch("Router/actionSetTransition", false)
}

function clearEntities() {
  store.dispatch("EntityLoader/actionClearEntities")
}

router.beforeEach((to, from, next) => {
  startTransition()
  // if (from.matched.map(item => item.path).toString() != to.matched.map(item => item.path).toString() && !from.meta.entityKeep && !to.meta.entityKeep) {
  // clearEntities()
  // }
  if (from.matched.length > 1 && to.matched.length > 1) {
    let pathFrom = from.matched[from.matched.length - 1].path
    let pathTo = to.matched[to.matched.length - 1].path
    let pathFromSplit = pathFrom.split("/")
    let pathToSplit = pathTo.split("/")

    if (pathFromSplit.length > 2 && pathToSplit.length > 2 && pathFromSplit[2] !== pathToSplit[2]) {
      clearEntities()
    }
  }

  let pageNotFound = isPageNotFound(to)
  let isAuthenticated = Auth.isAuthenticated()
  let pageNotFoundAndUserNotAuthenticated = pageNotFound && !isAuthenticated
  let pageRequiresAuthButUserNotAuthenticated = isAuthRequired(to) && !isAuthenticated
  let loginPageAndUserAuthenticated = isPageLogin(to) && isAuthenticated
  let requiresCertainModule = isModuleRequired(to)
  let isModuleOk = checkModule(to)

  if (pageNotFoundAndUserNotAuthenticated || pageRequiresAuthButUserNotAuthenticated) {
    if (from.fullPath === "/login") {
      stopTransition()
      next(false)
    } else {
      next("/login")
    }
  }
  else if (loginPageAndUserAuthenticated) {
    if (from.fullPath === "/map") {
      stopTransition()
      next(false)
    } else {
      next("/")
    }
  }
  else if (pageNotFound) {
    next("/")
  }
  else {
    next()
  }
})
router.afterEach((to) => {
  setDocumentTitle(to)
  stopTransition()
  sendStatistics(to)
})
router.onError(err => {
  stopTransition()
  alert(err)
})

export {router}
